import { onboarding } from '@services';
import OnboardingGroup, {
  IOnboardingGroup,
  IOnboardingGroupApi,
  IPaginationResultGroups,
} from '@models/OnboardingGroup.model';
import IdentifiedOnboardingGroup, {
  IIdentifiedOnboardingGroupApi,
  IdentifiedOnboardingGroup as IdentifiedOnboardingGroupInterface,
} from '@models/IdentifiedOnboardingGroup.model';

interface IRequest {
  studioId: string;
  fileId: string;
  search?: string;
  perPage: number;
  page: number;
  status?: string | null;
}

const getGroupedAssetsWithSearch = async ({
  studioId,
  fileId,
  search,
  perPage,
  page,
  status,
}: IRequest): Promise<IPaginationResultGroups<IOnboardingGroup>> => {
  const { data: groups } = await onboarding.get<
    IPaginationResultGroups<IOnboardingGroupApi>
  >(
    `/api/v1/assets/search/status?studioId=${studioId}&fileId=${fileId}&search=${search}&perPage=${perPage}&page=${page}&status=${status}&isGrouped=true`,
  );

  return OnboardingGroup.arrayPaginatedFromApiModel(groups);
};

const getGroupedIdentifiedAssetsWithSearch = async ({
  studioId,
  fileId,
  search,
  perPage,
  page,
}: IRequest): Promise<
  IPaginationResultGroups<IdentifiedOnboardingGroupInterface>
> => {
  const { data: groups } = await onboarding.get<
    IPaginationResultGroups<IIdentifiedOnboardingGroupApi>
  >(
    `/api/v1/assets/search/status/new?studioId=${studioId}&fileId=${fileId}&search=${search}&perPage=${perPage}&page=${page}&status=identified&isGrouped=true`,
  );

  return IdentifiedOnboardingGroup.arrayPaginatedFromApiModel(groups);
};

export { getGroupedAssetsWithSearch, getGroupedIdentifiedAssetsWithSearch };
